export default __webpack_public_path__ + "static/media/purolab_black.096ebd8e.png";